import React from "react";


import { NavLink } from "react-router-dom";


import "./index.scss";


type LinkComponentProps = {
    href: string;
    text: string;
    size? : 's' | 'm';
    inverted?: boolean;
    title?: string;
};


export const LinkComponent:React.FC<LinkComponentProps> = ({
    href, text, size = 'm', inverted = false,
    title
}) => {

    const cssClasses = `link-component size-${size}` + (inverted ? ' inverted' : '');

    return (
        <NavLink to={href} title={title ?? text} className={cssClasses}>
            <span>{text}</span>
        </NavLink>
    );

};


export default LinkComponent;
